import React, { useEffect, useState } from 'react';
import DownloadIcon from '@mui/icons-material/Download';
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  Container,
} from '@mui/material';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';

const OngoingSurveysPage = () => {
  const [enquetesEncours, setEnquetesEncours] = useState([]);
  const [enquetesPlanifiees, setEnquetesPlanifiees] = useState([]);

  useEffect(() => {
    // Enquêtes en cours
    setEnquetesEncours([
   {
  id: 1,
  nom: "Enquête Intégrée sur les Conditions de Vie des Ménages au Burundi (EICVMB 2025-2026)",
  objectifs: "Fournir des données statistiques fiables et actualisées afin de mesurer la pauvreté, d’analyser les conditions de vie des ménages (santé, éducation, emploi, logement) et de soutenir l’élaboration, le suivi et l’évaluation des politiques publiques de développement social et économique au Burundi.",
  domaine: "Conditions de vie des ménages, pauvreté et développement social",
  regions: "Ensemble des provinces du Burundi"
    }
    ,
    {
  id: 2,
  nom: "Enquête Nationale Agricole Rénovée du Burundi (ENARB) issue du RGPHAE",
  objectifs: "Produire des données statistiques fiables et actualisées sur le secteur agricole afin d’évaluer la production agricole, les pratiques culturales, l’utilisation des intrants et les conditions de travail des exploitations agricoles, et de soutenir l’élaboration, le suivi et l’évaluation des politiques publiques de développement agricole et de sécurité alimentaire au Burundi.",
  domaine: "Agriculture, élevage et sécurité alimentaire",
  regions: "Ensemble des provinces du Burundi"
},
{
  id: 3,
  nom: "Enquête du module agricole de base détaillé du Recensement Général de la Population, de l’Habitat, de l’Agriculture et de l’Élevage (RGPHAE)",
  objectifs: "Produire des données statistiques fiables et exhaustives sur les exploitations agricoles et d’élevage afin d’analyser les structures de production, les pratiques agricoles et les caractéristiques des exploitations, et de soutenir l’élaboration, le suivi et l’évaluation des politiques publiques de développement agricole et rural au Burundi.",
  domaine: "Agriculture, élevage et structures des exploitations agricoles",
  regions: "Ensemble des provinces du Burundi"
}
,
{
  id: 4,
  nom: "Enquête Nationale Agricole du Burundi (ENAB 2024-2025)",
  objectifs: "Produire des données statistiques fiables et actualisées sur la production agricole et les pratiques culturales des exploitations agricoles afin de soutenir l’élaboration, le suivi et l’évaluation des politiques publiques de développement agricole et de sécurité alimentaire au Burundi.",
  domaine: "Agriculture, production agricole et pratiques culturales",
  regions: "Ensemble des provinces du Burundi"
}


    
    ]);

    // Enquêtes planifiées
    setEnquetesPlanifiees([
      /*{
        id: 1,
        nom: 'Enquête sur la santé publique 2025',
        objectifs: 'Analyser l’état de la santé publique et les besoins en matière de santé.',
        domaine: 'Santé',
        regions: 'Toutes les provinces',
      }*/
    ]);
  }, []);

  return (
    <div style={{ backgroundColor: '#f8f9fa', padding: 4 }}>
      <NavigationBar />
      <Container maxWidth="lg" style={{ paddingTop: '54px' }}>
        <Typography variant="h4" gutterBottom sx={{ textAlign: 'justify', color: 'green', fontWeight: 'bold' }}>
          Enquêtes
        </Typography>
        
        {/* Introduction */}
        <Typography variant="body1" sx={{ marginBottom: 4 }}>
          Afin de garantir la transparence de nos activités statistiques et d'informer le public sur les travaux de collecte en cours, cette page répertorie l'ensemble des enquêtes nationales actives ainsi que celles programmées. Ces opérations sont essentielles pour la production de données fiables nécessaires au pilotage du développement du pays</Typography>
        <Grid container spacing={4}>
          {/* Enquêtes en cours */}
          <Grid item xs={12} sm={6}>
            <Box sx={{ backgroundColor: '#e0f7fa', padding: 2, borderRadius: 2 }}>
              <Typography variant="h5" gutterBottom sx={{ color: 'green', fontWeight: 'bold' }}>
                Enquêtes en cours
              </Typography>
              {enquetesEncours.length === 0 ? (
                <Box display="flex" justifyContent="center" alignItems="center" sx={{ height: '40vh', flexDirection: 'column' }}>
                  <Typography variant="h6" sx={{ marginBottom: 2 }}>
                    Aucune enquête en cours
                  </Typography>
                  <Typography variant="body1">
                    Nous n'avons actuellement aucune enquête en cours. Veuillez revenir plus tard pour les dernières informations.
                  </Typography>
                </Box>
              ) : (
                <Grid container spacing={1}>
                  {enquetesEncours.map((enquete) => (
                    <Grid item xs={12} key={enquete.id}>
                      <Card sx={{ height: '100%', boxShadow: 3, borderRadius: 2, display: 'flex', flexDirection: 'column' }}>
                        <CardContent sx={{ flexGrow: 1 }}>
                          <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'green' }}>{enquete.nom}</Typography>
                          <Typography variant="body2">Objectifs : {enquete.objectifs}</Typography>
                          <Typography variant="body2">Domaine : {enquete.domaine}</Typography>
                          <Typography variant="body2">Régions : {enquete.regions}</Typography>
                        </CardContent>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
              )}
            </Box>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Box sx={{ backgroundColor: '#fff3e0', padding: 2, borderRadius: 2 }}>
              <Typography variant="h5" gutterBottom sx={{ color: 'green', fontWeight: 'bold' }}>
                Enquêtes planifiées
              </Typography>
              {enquetesPlanifiees.length === 0 ? (
                <Box display="flex" justifyContent="center" alignItems="center" sx={{ height: '40vh', flexDirection: 'column' }}>
                 
                  <Typography variant="body1">
                    Nous n'avons actuellement aucune enquête planifiée. Veuillez revenir plus tard pour les prochaines informations.
                  </Typography>
                </Box>
              ) : (
                <Grid container spacing={1}>
                  {enquetesPlanifiees.map((enquete) => (
                    <Grid item xs={12} key={enquete.id}>
                      <Card sx={{ height: '100%', boxShadow: 3, borderRadius: 2, display: 'flex', flexDirection: 'column' }}>
                        <CardContent sx={{ flexGrow: 1 }}>
                          <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'green' }}>{enquete.nom}</Typography>
                          <Typography variant="body2">Objectifs : {enquete.objectifs}</Typography>
                          <Typography variant="body2">Domaine : {enquete.domaine}</Typography>
                          <Typography variant="body2">Régions : {enquete.regions}</Typography>
                        </CardContent>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
              )}
            </Box>
          </Grid>
        
        </Grid>
      </Container>
      <br />
      <br />
      <Footer />
    </div>
  );
};

export default OngoingSurveysPage;
